import { render, staticRenderFns } from "./AmountCard.vue?vue&type=template&id=6e32236a&scoped=true&"
import script from "./AmountCard.vue?vue&type=script&lang=js&"
export * from "./AmountCard.vue?vue&type=script&lang=js&"
import style0 from "./AmountCard.vue?vue&type=style&index=0&id=6e32236a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e32236a",
  null
  
)

export default component.exports